export enum SkVinServiceReturnCode {
    Results = 0,
    NoResults = 1
}